import { PureComponent } from "react";

import { BTCheckbox } from "commonComponents/btWrappers/BTCheckbox/BTCheckbox";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

type CellType = boolean | undefined;

class CheckBoxCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        const { cellValue, field } = this.props;
        return (
            <BTCheckbox
                id={field.full}
                data-testid={field.full}
                checked={cellValue || false}
                disabled
            />
        );
    }
}

export const columnCheckbox: IClientGridColumn<CellType> = {
    columnType: GridColumnType.checkbox,
    Cell: CheckBoxCell,
};
